import { Patient } from '@medplum/fhirtypes';

function sortedStrings(values: (string | undefined)[] | undefined): string[] {
  return (values ?? []).filter((value): value is string => Boolean(value)).sort();
}
/**
 * Create a key of patient information necessary to sync the patient to DoseSpot.
 */
export function buildDoseSpotDemographicKey(patient: Patient | undefined): string {
  if (!patient) {
    return 'no-patient';
  }

  const names = (patient.name ?? [])
    .map((name) => ({
      given: sortedStrings(name.given),
      family: name.family ?? '',
      suffix: sortedStrings(name.suffix),
    }))
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

  const addresses = (patient.address ?? [])
    .map((address) => ({
      line: sortedStrings(address.line),
      city: address.city ?? '',
      state: address.state ?? '',
      postalCode: address.postalCode ?? '',
      country: address.country ?? '',
    }))
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

  const telecom = (patient.telecom ?? [])
    .filter((contactPoint) => contactPoint.system === 'phone' || contactPoint.system === 'email')
    .map((contactPoint) => ({
      system: contactPoint.system ?? '',
      use: contactPoint.use ?? '',
      value: contactPoint.value ?? '',
    }))
    .sort((a, b) => JSON.stringify(a).localeCompare(JSON.stringify(b)));

  return JSON.stringify({
    names,
    addresses,
    telecom,
    birthDate: patient.birthDate ?? '',
  });
}
